import React from 'react';
import { Message } from 'primereact/message';
import { bdi_severity } from './AtributosBDI';

const MessageBDI = props => {
    return React.createElement(Message, { severity: props.severity, text: props.text });
};

MessageBDI.bdi_severity = bdi_severity;

export default MessageBDI;